import React, { useEffect, useState } from "react";
import { FormControl, TextField } from "@mui/material";
import localize from "../../../common/localize";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";

export default function AddOrEditResolution({ model, setModel }) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription = MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  useEffect(() => {
    if (model.Description) {
      setDescriptionCount(model.Description.length);
    }
  }, [model?.Description]);

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full mt-2">
        <div className="flex flex-wrap mb-6">
          <FormControl required fullWidth>
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Code"
              label={localize.code}
              variant="outlined"
              onChange={handleChange}
              value={model.Code}
            />
          </FormControl>
        </div>

        <div className="flex flex-wrap mb-6">
          <FormControl required fullWidth>
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              id="outlined-basic"
              name="Name"
              label={localize.name}
              variant="outlined"
              onChange={handleChange}
              value={model.Name}
            />
          </FormControl>
        </div>

        <div className="flex flex-wrap mb-6">
          <FormControl required fullWidth>
            <TextField
              InputLabelProps={{ style: { fontSize: "1em" } }}
              inputProps={{
                style: {
                  fontSize: "0.8em",
                },
                maxLength: maximumCharactersForDescription,
              }}
              size="small"
              fullWidth
              multiline
              rows={3}
              id="outlined-basic"
              name="Description"
              label={localize.description}
              variant="outlined"
              onChange={handleChange}
              value={model.Description}
              helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
            />
          </FormControl>
        </div>
      </form>
    </div>
  );
}
